import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const CARD = ({ icon, title, children }) => (
  <div style={{ background:'#fff',borderRadius:16,padding:'28px 24px',border:'1px solid rgba(26,60,143,0.1)',boxShadow:'0 4px 20px rgba(26,60,143,0.06)',textAlign:'center' }}>
    <div style={{ fontSize:36,marginBottom:12 }}>{icon}</div>
    <h3 style={{ fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:700,color:'#1A1A2E',marginBottom:8 }}>{title}</h3>
    {children}
  </div>
);

export default function Contact() {
  const [sent, setSent] = useState(false);

  const openWhatsApp = () => {
    window.open('https://wa.me/919443724724?text=Hello%20TNPSC%20Hub%2C%20I%20have%20a%20query%3A', '_blank');
  };

  return (
    <div style={{ fontFamily:"'Sora',sans-serif", background:'#F8F9FF', minHeight:'100vh' }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700&family=Playfair+Display:wght@700;900&display=swap'); ::-webkit-scrollbar{width:6px} ::-webkit-scrollbar-thumb{background:#1A3C8F;border-radius:10px}`}</style>

      {/* Nav */}
      <nav style={{ position:'fixed',top:0,left:0,right:0,zIndex:100,height:68,padding:'0 5%',display:'flex',alignItems:'center',justifyContent:'space-between',background:'rgba(248,249,255,0.92)',backdropFilter:'blur(20px)',borderBottom:'1px solid rgba(26,60,143,0.1)' }}>
        <Link to="/" style={{ display:'flex',alignItems:'center',gap:10,textDecoration:'none' }}>
          <div style={{ width:38,height:38,background:'linear-gradient(135deg,#1A3C8F,#2451b3)',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',fontSize:17 }}>🏆</div>
          <span style={{ fontFamily:"'Playfair Display',serif",fontSize:21,fontWeight:700,color:'#1A3C8F' }}>TNPSC <em style={{ color:'#F5A623',fontStyle:'normal' }}>Hub</em></span>
        </Link>
        <Link to="/" style={{ padding:'8px 20px',background:'linear-gradient(135deg,#F5A623,#e8940f)',borderRadius:8,color:'#102766',fontSize:13,fontWeight:700,textDecoration:'none' }}>← Back to Home</Link>
      </nav>

      {/* Hero */}
      <div style={{ background:'linear-gradient(135deg,#0d2158,#1A3C8F)',padding:'120px 5% 60px',textAlign:'center',position:'relative',overflow:'hidden' }}>
        <div style={{ position:'absolute',width:500,height:500,background:'radial-gradient(circle,rgba(245,166,35,0.15),transparent 70%)',top:-100,right:-50,pointerEvents:'none' }}/>
        <div style={{ display:'inline-flex',alignItems:'center',gap:8,background:'rgba(245,166,35,0.15)',border:'1px solid rgba(245,166,35,0.4)',borderRadius:50,padding:'6px 18px',color:'#F5A623',fontSize:12,fontWeight:700,letterSpacing:'1.5px',textTransform:'uppercase',marginBottom:20 }}>💬 Get in Touch</div>
        <h1 style={{ fontFamily:"'Playfair Display',serif",fontSize:'clamp(28px,5vw,48px)',fontWeight:900,color:'#fff',marginBottom:16 }}>Contact Us</h1>
        <p style={{ color:'rgba(255,255,255,0.6)',fontSize:15,maxWidth:500,margin:'0 auto' }}>We're here to help! Reach out with any questions about registration, payments, or platform access.</p>
      </div>
      <div style={{ lineHeight:0,background:'linear-gradient(135deg,#0d2158,#1A3C8F)' }}><svg viewBox="0 0 1440 40" fill="none" style={{ display:'block',width:'100%' }}><path d="M0,20 C360,40 1080,0 1440,20 L1440,40 L0,40 Z" fill="#F8F9FF"/></svg></div>

      {/* Contact cards */}
      <div style={{ maxWidth:900,margin:'0 auto',padding:'60px 5% 40px' }}>
        <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:24,marginBottom:60 }}>

          <CARD icon="📧" title="Email Us">
            <p style={{ color:'#777',fontSize:13,marginBottom:14 }}>For general queries, payment issues, or account support</p>
            <a href="mailto:support@tnpschub.msdiscoveries.com" style={{ display:'block',width:'100%',boxSizing:'border-box',padding:'10px 12px',background:'linear-gradient(135deg,#1A3C8F,#2451b3)',color:'#fff',borderRadius:10,fontSize:12,fontWeight:600,textDecoration:'none',textAlign:'center',wordBreak:'break-all' }}>
              support@tnpschub.msdiscoveries.com
            </a>
          </CARD>

          <CARD icon="📞" title="Call Us">
            <p style={{ color:'#777',fontSize:13,marginBottom:14 }}>Available Mon–Sat, 9 AM – 6 PM</p>
            <a href="tel:9443724724" style={{ display:'inline-block',padding:'10px 28px',background:'linear-gradient(135deg,#1A3C8F,#2451b3)',color:'#fff',borderRadius:10,fontSize:15,fontWeight:700,textDecoration:'none' }}>
              9443724724
            </a>
          </CARD>

          <CARD icon="💬" title="WhatsApp">
            <p style={{ color:'#777',fontSize:13,marginBottom:14 }}>Quick replies for urgent payment or login issues</p>
            <button onClick={openWhatsApp} style={{ padding:'10px 24px',background:'linear-gradient(135deg,#25D366,#128C7E)',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer' }}>
              Chat on WhatsApp
            </button>
          </CARD>

        </div>

        {/* FAQ section */}
        <div style={{ background:'#fff',borderRadius:20,padding:'36px',border:'1px solid rgba(26,60,143,0.1)',boxShadow:'0 4px 20px rgba(26,60,143,0.06)',marginBottom:48 }}>
          <h2 style={{ fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:700,color:'#1A1A2E',marginBottom:28,textAlign:'center' }}>Frequently Asked Questions</h2>
          {[
            { q:'How long does account activation take?', a:'Your account is activated within 24 hours of payment verification on working days.' },
            { q:'What payment methods do you accept?', a:'We accept UPI payments only. Pay ₹499 to UPI ID: danarajmuthu28@okicici and submit your UTR ID during registration.' },
            { q:'I made a payment but my account is not active yet.', a:'Contact us at support@tnpschub.msdiscoveries.com with your UTR ID, registered email, and payment screenshot. We\'ll resolve it within 24 hours.' },
            { q:'Can I change my exam group after registration?', a:'Please contact us directly to request a group change. Note that refunds are not available.' },
            { q:'I forgot my password. How do I reset it?', a:'Use the "Forgot Password" option on the login page. You can contact the admin via WhatsApp or request a password reset from your profile page after login.' },
          ].map(({ q, a }, i) => (
            <div key={i} style={{ borderBottom: i < 4 ? '1px solid rgba(26,60,143,0.07)' : 'none', paddingBottom: i < 4 ? 20 : 0, marginBottom: i < 4 ? 20 : 0 }}>
              <h4 style={{ fontWeight:700, color:'#1A3C8F', fontSize:15, marginBottom:6 }}>❓ {q}</h4>
              <p style={{ color:'#666', fontSize:14, lineHeight:1.7, margin:0 }}>{a}</p>
            </div>
          ))}
        </div>

        {/* Office hours */}
        <div style={{ background:'linear-gradient(135deg,#102766,#1A3C8F)',borderRadius:20,padding:36,textAlign:'center' }}>
          <h3 style={{ fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:700,color:'#fff',marginBottom:8 }}>Support Hours</h3>
          <p style={{ color:'rgba(255,255,255,0.7)',fontSize:14,marginBottom:18 }}>Monday – Saturday &nbsp;|&nbsp; 9:00 AM – 6:00 PM IST</p>
          <p style={{ color:'rgba(255,255,255,0.5)',fontSize:12 }}>Responses to email queries within 24 hours on working days.</p>
        </div>
      </div>

      <footer style={{ background:'#1A1A2E',padding:'24px 5%',textAlign:'center' }}>
        <p style={{ color:'rgba(255,255,255,0.35)',fontSize:12 }}>© 2026 TNPSC Hub — msdiscoveries.com. All rights reserved.</p>
        <div style={{ marginTop:10,display:'flex',justifyContent:'center',gap:20 }}>
          {[['/', 'Home'],['/terms','Terms'],['/privacy','Privacy'],['/refund','Refund Policy']].map(([to,label])=>(
            <Link key={to} to={to} style={{ color:'rgba(255,255,255,0.35)',fontSize:12,textDecoration:'none' }}>{label}</Link>
          ))}
        </div>
      </footer>
    </div>
  );
}
